import { ComputedRef } from 'vue'

import { ChallengeLargeClassification } from '@/domain/entities/problem/challengeLargeClassification'
import { ChallengeMiddleClassification } from '@/domain/entities/problem/challengeMiddleClassification'
import { Contest } from '@/domain/entities/problem/contest'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ChallengeViewModel } from '@/presentation/viewmodels/problem/challengeViewModel'

export class ChallengePresenter {
  private viewModel: ChallengeViewModel

  constructor(viewModel: ChallengeViewModel) {
    this.viewModel = viewModel
  }

  get largeClassificationList(): ComputedRef<{ [id: string]: ChallengeLargeClassification }> {
    return this.viewModel.largeClassificationList
  }

  get middleClassificationList(): ComputedRef<{ [largeClassificationId: string]: ChallengeMiddleClassification[] }> {
    return this.viewModel.middleClassificationList
  }

  get contestList(): ComputedRef<{ [largeClassificationId: string]: { [middleClassificationId: string]: Contest[] } }> {
    return this.viewModel.contestList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getChallengeList(displayLanguage: DisplayLanguageType): Promise<void> {
    await this.viewModel.getChallengeList(displayLanguage)
  }

  async getChallengeById(
    displayLanguage: DisplayLanguageType,
    challengeLargeClassificationId: string,
    challengeMiddleClassificationId: string
  ): Promise<void> {
    await this.viewModel.getChallengeById(
      displayLanguage,
      challengeLargeClassificationId,
      challengeMiddleClassificationId
    )
  }
}
